import { Layout } from '@shopify/polaris';
import { colorValueToCssVar } from '@/helpers';
import { RGBAColor } from '@shopify/polaris';
import styled from 'styled-components';

export const PolarisLayout = styled(Layout)``;

export const CollapsibleCardHeader = styled.div`
  display: flex;
  column-gap: 11px;
`;

export const StyledAligment = styled.div`
  padding: 5px 10px;
  background: #ebebeb;
  border-radius: 10px;

  .Polaris-Button--iconOnly:is(.Polaris-Button--variantTertiary) {
    margin: initial;
  }

  .Polaris-Button--pressed.Polaris-Button--pressed,
  .Polaris-Button--pressed.Polaris-Button--pressed:hover,
  .Polaris-Button--pressed.Polaris-Button--pressed:active,
  .Polaris-Button--pressed.Polaris-Button--pressed:focus-visible svg {
    background: #fff;
  }
`;

export const ColorBox = styled.div<{ colorValue: RGBAColor }>`
  width: 22px;
  height: 22px;
  background-color: ${({ colorValue }) => colorValueToCssVar(colorValue)};
`;

export const StyledCSSBox = styled.div<{isDisable: boolean}>`
  margin-top: 4px;
  padding: 6px 12px;
  border: 1px solid rgb(137 137 137);
  border-radius: 10px;
  background: ${({ isDisable }) => isDisable ? "#ddd" : "#fff"};

  .ace_content {
    background: ${({ isDisable }) => isDisable ? "#ddd" : "#fff"};
  }
`;

export const StyledFlexGrow = styled.div`
  flex-grow: 1;
`;

export const StyledSortBox = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  border: 1px solid #ebebeb;
  border-radius: 10px;
  background: #fff;
  overflow: hidden;
  min-width: 190px;
  font-weight: 500;
`;

export const StyledSection = styled.div`
    position: sticky;
    top: 68px;
`
